import React, { useState } from 'react'
import Input from '../components/Form Elements/Input'
import AnimatePage from '../components/AnimatePage'
import Wrapper from '../helpers/Wrapper'
import SectionHead from '../components/SectionHead'
import Button from '../ui/Button'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

function Track() {

    const [orderNumber, setOrderNumber] = useState("")
    const navigate = useNavigate()


    // Handle Order Tracking
    const { mutate, isPending } = useMutation({
        mutationFn: (formData) => {
            return apiClient.post('/track', formData)
        },
        onError: (err) => {
            toast.dismiss()
            toast.error(err?.response?.data || err?.message)
        },
        onSuccess: (data) => {
            navigate(`/order-tracking/${data?.data?.orderNumber}`)
        }
    })

    const handleTracking = () => {
        if (orderNumber.length > 0) {
            mutate({ order_number: orderNumber })
        }
    }


    return (
        <AnimatePage>
            <Wrapper>
                <div className='w-full relative my-10 max-w-4xl mx-auto'>

                    {/* Section Head */}
                    <SectionHead title={"Track Your Order"} description={"Monitor your order's journey from purchase to delivery in real time with ease."} />

                    {/* Input Field Area */}
                    <div className="w-full space-y-3 mt-10 flex flex-col items-center">
                        <Input placeholder="Order number" value={orderNumber} onChange={(e) => setOrderNumber(e.target?.value)} />
                        <Button loading={isPending} onClick={handleTracking}>Track</Button>
                    </div>
                </div>
            </Wrapper>
        </AnimatePage>
    )
}

export default Track